export const query = `query getCartService($cartId: String, $locale: String!, $checkoutId: String) {
  cartService {
    cart(cartId: $cartId, checkoutId: $checkoutId) {
      cartId
      checkoutId
      additionalFees {
        code
        name
        totalPrice
        formattedTotalPrice
      }
      totals(withTax: true, withShipping: true) {
        subTotal
        total
        shipping
        discount
        itemsTotal
        tax
        formattedItemsTotal
        formattedSubTotal
        formattedShipping
        formattedDiscount
        formattedTax
        formattedTotal
        additionalFeesTotal
      }
      selectedShippingOption{
        id
        title
        rate
        formattedRate
        deliveryTime
        carrierId
        pickupInfo {
          address {
            countryName(translateTo: $locale)
            subdivisionName(translateTo: $locale)
            addressLine
            city
            zipCode
          }
        }
      }
      shippingRuleInfo {
        status
        canShipToDestination
        shippingRule {
          id
          options {
            id
            title
            rate: convertedRate
            formattedRate: convertedFormattedRate
            deliveryTime
            pickupInfo {
              address {
                countryName(translateTo: $locale)
                subdivisionName(translateTo: $locale)
                addressLine
                city
                zipCode
              }
            }
          }
        }
      }
      destinationCompleteness
    }
  }
}`;
